#!/usr/bin/env node
import runCLI from './cli';

void runCLI();
